import { formatMoney as format } from 'accounting';

/*
Formats value as money, returns "-" if value is invalid
*/
export const formatMoney = (value, isInvalid = false, options = {}) => {
  if (isInvalid) {
    return '-';
  }

  return format(value, options);
};

export const formatUSD = (value, isInvalid) => {
  if (window.gon?.global?.jh) {
    return formatMoney(value, isInvalid, { symbol: '¥', format: '%s %v' });
  }

  return formatMoney(value, isInvalid, { symbol: 'USD', format: '%v %s' });
};
